import { createURL } from '@sm/utils';
import { t } from '@sm/intl';
import getHelpLink from '../../../../helpers/getHelpLink';
import COPY from './getFooterCopy';

const getAuthFooterLinks = (domain, lang) => {
  const items = [
    {
      title: t(COPY.ABOUT_SURVEYMONKEY),
      url: createURL('/mp/aboutus/', { ut_source: 'footer' }),
    },
    {
      title: t(COPY.CAREERS),
      url: createURL('/careers/', { ut_source: 'footer' }),
    },
    {
      title: t(COPY.DEVELOPERS),
      url: createURL(`https://developer.${domain}.com/`, {
        ut_source: 'footer',
      }),
    },
    {
      title: t(COPY.PRIVACY_NOTICE),
      url: createURL('/mp/legal/privacy/', { ut_source: 'footer' }),
    },
    {
      title: t(COPY.CALIFORNIA_PRIVACY_NOTICE),
      url: createURL('/mp/legal/region-specific-privacy-statement/', {
        ut_source: 'footer',
      }),
    },
    lang === 'de' && {
      title: 'Impressum',
      url: createURL('/mp/impressum/', { ut_source: 'footer' }),
    },
    {
      title: t(COPY.EMAIL_OPT_IN),
      url: createURL('/user/email-opt-in/', { ut_source: 'footer' }),
    },
    {
      title: t(COPY.HELP),
      url: getHelpLink(lang, {
        params: { ut_source: 'footer' },
      }),
    },
    {
      title: t(COPY.COOKIES_NOTICE),
      url: createURL('/mp/legal/cookies/', { ut_source: 'footer' }),
    },
  ];
  return items.filter(Boolean);
};

export default getAuthFooterLinks;
